'use strict';

angular.module('systemOwnerReviewControllers.ReviewUniquePermissions')

.controller('SideBarUniquePermissionsController', ['$scope', 'authLogin', 'systemTypesToReview', function ($scope, authLogin, systemTypesToReview) {

    $scope.sideBarSystemTypes = systemTypesToReview;
}]);
